// Uploads iguais no mesmo título usam a mesma chave, inclusive após recarregar a página.
export async function attachmentRequestKey(url, companyId, data) {
  const bytes = new TextEncoder().encode(JSON.stringify([url, companyId, data.id_conta, data.descricao, data.arquivo_base64]));
  const digest = await window.crypto.subtle.digest('SHA-256', bytes);
  return `arquivo-${Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('')}`;
}
